// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8dd433a3","488":"01e74d71"}[chunkId] + ".chunk.js";
};